<div class="col-12">
  <app-about></app-about>
  <img id="roots-back-image" src="../../../assets/svgs/plants-original.svg" 
  style="position: absolute; z-index: -1000; top: 25%; opacity: 50%;" class="col-12" />
</div>
